import type {SearchRules} from '../../types';
import {SearchTypeCategoryId} from '../';

/**
 * Check if rules contain specified category id
 * @param searchRules Search rules
 * @param id Category id
 * @returns Contains category id
 */
export const rulesContainCategoryId = (searchRules: SearchRules, id: number) =>
	searchRules.elementTypes.some(
		(elementType, index) =>
			elementType === SearchTypeCategoryId &&
			searchRules.elementValue1s[index] === id,
	);

export default rulesContainCategoryId;
